import React from 'react';
import { Form, Input, Select } from 'antd';
import { AddItemFormData } from './types';

const { Option } = Select;
const { TextArea } = Input;

interface SkillDetailsProps {
  styles: { [key: string]: string };
  formData: AddItemFormData;
}

const SkillDetails: React.FC<SkillDetailsProps> = ({ styles, formData }) => (
  <div className={styles.stepContainer}>
    <h2 className={styles.stepTitle}>Basic Details</h2>

    <div className={styles.wearableBasicsWrapper}>
      <div className={styles.wearableThumbnailPreview}>
        {formData.thumbnail && formData.thumbnail.length > 0 ? (
          <img
            src={URL.createObjectURL(formData.thumbnail[0])}
            alt="Skill preview"
            className={styles.wearablePreviewImage}
          />
        ) : (
          <div className={styles.wearableNoImage}>
            <p>No image selected</p>
          </div>
        )}
        {formData.thumbnail && formData.thumbnail.length > 0 && (
          <p className={styles.fileName}>
            {formData.thumbnail[0]?.name}
          </p>
        )}
      </div>

      <div className={styles.wearableFormGrid}>
        <div className={styles.wearableFormColumn}>
          <Form.Item
            label="Type"
            name="type"
            rules={[{ required: true, message: 'Please enter a type' }]}
            className={styles.formItem}
          >
            <Input placeholder="Enter Type" className={styles.textInput} />
          </Form.Item>

          <Form.Item
            label="Industry"
            name="industry"
            rules={[{ required: true, message: 'Please select an industry' }]}
            className={styles.formItem}
          >
            <Select placeholder="Select Industry" className={styles.selectInput}>
              <Option value="general">General</Option>
              <Option value="healthcare">Healthcare</Option>
              <Option value="finance">Finance</Option>
              <Option value="ecommerce">E-commerce</Option>
              <Option value="insurance">Insurance</Option>
              <Option value="retail">Retail</Option>
            </Select>
          </Form.Item>

         
        </div>

        <div className={styles.wearableFormColumn}>
          <Form.Item
            label="Language"
            name="language"
            rules={[{ required: true, message: 'Please select a language' }]}
            className={styles.formItem}
          >
            <Select placeholder="Select Language" className={styles.selectInput}>
              <Option value="english-us">English (US)</Option>
              <Option value="english-uk">English (UK)</Option>
            </Select>
          </Form.Item>

           <Form.Item
              label="Version"
              name="version"
              className={styles.formItem}
            >
              <Input placeholder="Enter Version (e.g. 1.0.0)" className={styles.textInput} />
            </Form.Item>

          {/* <Form.Item
            label="Marketplace ID"
            name="marketplaceId"
            className={styles.formItem}
          >
            <Input placeholder="Enter Marketplace ID" className={styles.textInput} />
          </Form.Item> 

          <Form.Item
            label="Last Verified By"
            name="lastVerifiedBy"
            className={styles.formItem}
          >
            <Input placeholder="Enter Verifier Name" className={styles.textInput} />
          </Form.Item>*/}
        </div>
      </div>
    </div>

    <div className={styles.wearableFullWidth}>
      <Form.Item
        label="Name"
        name="itemName"
        rules={[{ required: true, message: 'Please enter an item name' }]}
        className={styles.formItem}
      >
        <Input placeholder="Enter Item Name" className={styles.textInput} />
      </Form.Item>

      <Form.Item
        label="Tags"
        name="tags"
        className={styles.formItem}
      >
        <Input placeholder="Enter Tags (comma-separated)" className={styles.textInput} />
      </Form.Item>

      {/* <Form.Item
        label="Last Verified At"
        name="lastVerifiedAt"
        className={styles.formItem}
      >
        <Input placeholder="YYYY-MM-DD" className={styles.textInput} />
      </Form.Item>

      <Form.Item
        label="Note"
        name="note"
        className={styles.formItem}
      >
        <Input placeholder="Enter Note" className={styles.textInput} />
      </Form.Item> */}
    </div>

    <Form.Item
      label="Content"
      name="content"
      className={`${styles.formItem}`}
    >
      <TextArea
        placeholder="Enter Skill Content"
        className={styles.textareaInput}
        rows={4}
      />
    </Form.Item>

    <Form.Item
      label="Description"
      name="description"
      rules={[{ required: true, message: 'Please enter a description' }]}
      className={styles.formItem}
    >
      <TextArea
        placeholder="Enter Description"
        className={styles.textareaInput}
        rows={6}
      />
    </Form.Item>

    <Form.Item
      label="Terms of Use"
      name="terms_of_use"
      className={styles.formItem}
    >
      <TextArea
        placeholder="Enter Terms of Use"
        className={styles.textareaInput}
        rows={4}
      />
    </Form.Item>

    <Form.Item
      label="Privacy Policy"
      name="privacy_policy"
      className={styles.formItem}
    >
      <TextArea
        placeholder="Enter Privacy Policy"
        className={styles.textareaInput}
        rows={4}
      />
    </Form.Item>
  </div>
);

export default SkillDetails;
